"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const PropTypes = tslib_1.__importStar(require("prop-types"));
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  align-self: flex-end;
  justify-content: center;
`;
const Footer = styled_components_1.default.div `
  text-align: center;
  font-size: ${polished_1.rem(12)};
  color: ${({ theme }) => theme.responsiveMenu.siteUrlColor};
  letter-spacing: ${polished_1.rem(1)};
  padding: ${polished_1.rem(30)} 0;
  border-top: ${polished_1.rem(3)} solid
    ${({ theme }) => theme.responsiveMenu.siteUrlBorder};
`;
const SiteUrl = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(Footer, null, props.siteUrl)));
};
SiteUrl.propTypes = {
    siteUrl: PropTypes.string.isRequired,
};
exports.default = SiteUrl;
